<template>
<svg x="0px" y="0px" viewBox="0 0 95 31">
  <g>
    <path :fill="getPrimaryColor()" d="M24.6,18.7c0.1-2.5-1.5-5.3-4.3-5.3c-2.7,0-4.4,2.8-4.4,5.3H24.6z M7.3,28.4c2.1,0,3.9-1.1,5.6-2.3
      c-0.4-1.3-0.6-2.6-0.6-4c-1.2-0.4-2.4-0.5-3.6-0.5c-2.4,0-4.7,1.1-4.7,3.7C4,27.4,5.5,28.4,7.3,28.4 M1.8,16.3
      C2.5,13.5,4.7,12,7.6,12c3.2,0,5,0.5,7.6,2.4c1.6-1.5,3.1-2.4,5.3-2.4c4.8,0,8,3.5,8.4,8.1H15.8c-0.3,4,1.9,8.4,6,8.4
      c2.5,0,4.9-1,6.4-2.5l0.8,0.7c-2.2,2.4-5.6,4.2-8.9,4.2c-2.7,0-5.4-1-6.8-3.4c-2.4,1.7-5.1,3.4-8.1,3.4c-2.9,0-5.1-1.9-5.1-4.8
      c0-4.7,5.9-5.5,12.2-5.6V17c0-2.4-1.4-3.6-3.9-3.6c-1.9,0-2.8,2-2.7,3.6L1.8,16.3z"/>
    <path :fill="getPrimaryColor()" d="M22.8,12.5c4,0.2,2.4,0.1,5.3,0.2c3.9-0.1,2.7,0,5.6-0.2v0.6c-1.3,0.2-2.9,0.8-2.9,2.3c0,2.1,4,9.6,4.8,11.2
      C37,24.3,41,17.4,41,15.5c0-1.8-1.2-2.2-2.7-2.4v-0.6c1.2,0.1,3.2,0.2,4.5,0.2c1.4,0,2.7-0.1,4.1-0.2v0.6c-1.6,0.1-3.2,1.2-5.2,5.2
      c-2.1,4.1-4.5,8-6.3,12.3h-1.7c-2-4.5-4.6-9.5-6.4-13.7c-0.8-1.8-2.3-3.5-4.4-3.8V12.5z"/>
    <path :fill="getPrimaryColor()" d="M46.3,18.3c0-3-0.2-4.6-3.5-4.9v-0.7L50,12v14.1c0,3.1,0.9,3.5,3.7,3.6v0.6c-2.2-0.1-4.4-0.2-6.6-0.2
      c-1.4,0-2.8,0.1-4.2,0.2v-0.6c2.5-0.1,3.5-0.5,3.5-3.6V18.3z"/>
    <path :fill="getPrimaryColor()" d="M49.5,14.2v-0.8c5.2-0.1,6.9-4.2,8-7.5h0.7v6.8h10.6v1.4H58.2v11c0,1.6,0.2,3.3,2.1,3.3c1.9,0,3-0.9,4.2-2.2
      l0.4,0.5c-2.1,1.9-4,4-7,4c-2.6,0-3.4-1.9-3.4-4V14.2H49.5z"/>
    <path :fill="getSecondaryColor()" d="M54.8,6.1c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6C52.1,0.1,54.8,2.8,54.8,6.1"/>
    <path :fill="getPrimaryColor()" d="M88.1,18.8c0.1-2.5-1.5-5.3-4.3-5.3c-2.7,0-4.4,2.8-4.4,5.3H88.1z M70.8,28.6c2.1,0,3.9-1.1,5.6-2.3
      c-0.4-1.3-0.6-2.6-0.6-4c-1.2-0.4-2.4-0.5-3.6-0.5c-2.4,0-4.7,1.1-4.7,3.7C67.5,27.5,69,28.6,70.8,28.6 M65.3,16.5
      c0.8-2.9,2.9-4.4,5.8-4.4c3.2,0,5,0.5,7.6,2.4c1.6-1.5,3.1-2.4,5.3-2.4c4.8,0,8,3.5,8.4,8.1H79.3c-0.3,4,1.9,8.4,6,8.4
      c2.5,0,4.9-1,6.4-2.5l0.8,0.7c-2.2,2.4-5.6,4.2-8.9,4.2c-2.7,0-5.4-1-6.8-3.4c-2.4,1.7-5.1,3.4-8.1,3.4c-2.9,0-5.1-1.9-5.1-4.8
      c0-4.7,5.9-5.5,12.2-5.6v-3.3c0-2.4-1.4-3.6-3.9-3.6c-1.9,0-2.8,2-2.7,3.6L65.3,16.5z"/>
  </g>
</svg>
</template>

<script>
export default {
  name: 'AevitaeLogo',
  props: {
    primaryColor: String,
    secondaryColor: String
  },
  methods: {
    getPrimaryColor () {
      return this.primaryColor ? this.primaryColor : '#3d4963';
    },
    getSecondaryColor () {
      return this.secondaryColor ? this.secondaryColor : '#008FB4';
    }
  }
};
</script>
